var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"3"}},[(_vm.$rbac.can('report.export'))?_c('v-btn',{attrs:{"color":"success"},on:{"click":_vm.excel}},[_c('v-icon',[_vm._v(" mdi-file-excel ")])],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }